module.exports = __webpack_public_path__ + "img/4.a70c5664.png";